import { render } from "./StoreLinks.vue?vue&type=template&id=838964d6&scoped=true"
import script from "./StoreLinks.vue?vue&type=script&lang=js"
export * from "./StoreLinks.vue?vue&type=script&lang=js"

import "./StoreLinks.vue?vue&type=style&index=0&id=838964d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838964d6"]])

export default __exports__